module.exports = __webpack_public_path__ + "static/6-c14fbb5bcf98b87ddcd7b9964f9572c2.jpg";